<template>
    <div>
        <div>
            <!-- 导航栏 -->
            <el-menu :default-active="activeIndex" class="el-menu-demo" style="background:#f2f2f2;display:flex;justify-content:center;align-items:center;" mode="horizontal" @select="handleSelect">
                <div style="margin-right:10px;font-size:13px;color:#999;">欢迎来到听说科技</div>
                <div style="margin:0 30px 0 10px;font-size:13px;color:#999;">欢迎您：{{this.userName}}</div>
                <el-menu-item index="1">
                    <router-link to="/refer">写作练习</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="2">
                    <router-link to="/articallist">我的文章</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="3">
                    <router-link to="/checkdetail">批改详情</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="4">
                    <router-link to="combo">我的套餐</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="5">
                    <router-link to="studentUser">用户中心</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="6">
                    <router-link to="studentShoppingCar">我的购物车</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="7">
                    <router-link to="/studentIndex">主页</router-link>
                </el-menu-item>
                <el-menu-item index="8">
                    <router-link to="/login">退出</router-link>
                </el-menu-item>
            </el-menu>
            <div style="width:50%;margin-left:25%;">
                <!-- logo + 输入框 -->
                <div style="margin-top:45px;display:flex;justify-content:space-around;height:42px;align-items:center;">
                    <img src="../../assets/images/logo.png" alt="图片加载失败" >
                    <div style="width:600px;height:42px;border:1px solid #FF2832;display:flex;align-items:center;border-radius:3px;">
                        <img src="../../assets/images/search.png" alt="图片加载失败" style="margin:0 5px 0 10px;">
                        <input type="text" style="width:480px;height:40px;border:0;outline:none;">
                        <button style="width:120px;height:42px;border:0;background:#FF2832;">搜索</button>
                    </div>
                </div>
                <!-- 文本输入框 -->
                <div style="width:100%;text-align:center;margin-top:30px;">
                    <textarea cols="113" rows="23" placeholder="请输入你的作文内容" style="padding:20px;line-height:20px;"></textarea><br>
                    <button class="refer" @click="sumit()">提 &nbsp;交</button>
                </div>   
            </div>
        </div>
    </div>
</template>
<script>
    import { home } from '@/api'

    export default {
        data(){
            return{
                activeIndex:'1',
                userName:'张三'
            }
        },
        mounted(){},
        methods:{
            handleSelect(key,keyPath){
                console.log(key,keyPath)
            },
            sumit(){
                //调接口
                home.refer().then( res=>{
                    console.log('成功！')
                }).catch( err=>{
                    console.log(err)
                })
                this.$router.push({path:'/studentIndex',query:{ type: 0 }})
            },
        }
    }
</script>
<style scoped>
    a{
        display:inline-block;
        width:100%;height:100%;
        text-decoration: none;
    }
    button.refer{
        width:200px;height:55px;
        font-size:25px;
        color:#333;
        border:0;
        border-radius:10px;
        background:#009688;
        margin-top:20px;
    }
    button.refer:hover{
        color:#000;
        background:#f00;
    }
</style>